var React = require('react');
var PropTypes = React.PropTypes;
import {Gateway} from 'react-gateway';
import ReactModal2 from 'react-modal2';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

var Confirm = React.createClass({

  render: function() {
    var actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.props.onCancel}
      />,
      <FlatButton
        label="OK"
        primary={true}
        disabled={true}
        onClick={this.props.onConfirm}
      />,
    ];
    return (
      <Gateway into="confirm-modal">
        <ReactModal2
          onClose={this.props.onClose}
          closeOnEsc={this.props.closeOnEsc}
          closeOnBackdropClick={this.props.closeOnEsc}
          backdropClassName='my-custom-backdrop-class'
          modalClassName='my-custom-modal-class'>
          <Dialog
            title={this.props.title}
            actions={actions}
            modal={true}
            open={true}
          >
            {this.props.content}
          </Dialog>
        </ReactModal2>
      </Gateway>
    );
  }

});

module.exports = Confirm;



/** WEBPACK FOOTER **
 ** ./src/components/Modal/Confirm.js
 **/